// extracted by mini-css-extract-plugin
export default {"infoArea":"yIl5wRiijLc7UrecEbyO","text":"PtU3fLkIewRcrUlhRYyd","common_bganimation":"CFnS9WmeIyspx0sYNdsY"};